import React, { useEffect, useState } from 'react';
import { MessageCircle, Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const navLinks = [{
  label: 'Inicio',
  href: '#inicio'
}, {
  label: 'El Problema',
  href: '#problema'
}, {
  label: 'Método 3en1',
  href: '#metodo'
}, {
  label: 'Resultados',
  href: '#resultados'
}, {
  label: 'Ubicación',
  href: '#ubicacion'
}, {
  label: 'Oferta',
  href: '#oferta'
}, {
  label: 'FAQ',
  href: '#faq'
}, {
  label: 'Contacto',
  href: '#contacto'
}];
export function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Lock body scroll when menu is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  const handleNavClick = (href: string) => {
    setIsOpen(false);
    const el = document.querySelector(href);
    if (el) {
      const offset = 80;
      const top = el.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({
        top,
        behavior: 'smooth'
      });
    }
  };
  return <>
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-gym-dark/98 backdrop-blur-md shadow-lg border-b border-gym-charcoalLight' : 'bg-gym-dark/90 backdrop-blur-sm border-b border-transparent'}`} data-id="element-176">
        <div className="max-w-6xl mx-auto px-4 h-20 flex items-center justify-between" data-id="element-177">
          {/* Logo */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.5
        }} className="flex items-center" data-id="element-178">
            <button onClick={() => handleNavClick('#inicio')} className="focus:outline-none" data-id="element-179">
              <img src="https://cdn.magicpatterns.com/uploads/oeddet9Q3MYGpU58ZCsPBn/logogym1.png" alt="Coach Pro Logo" className="h-12 w-auto object-contain" data-id="element-180" />
            </button>
          </motion.div>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-1" data-id="element-181">
            {navLinks.map(link => <button key={link.href} onClick={() => handleNavClick(link.href)} className="px-3 py-2 text-sm font-medium text-gray-300 hover:text-gym-green transition-colors uppercase tracking-wider" data-id="element-182">
                {link.label}
              </button>)}
          </nav>

          {/* Right side: CTA + Hamburger */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.5
        }} className="flex items-center gap-3" data-id="element-183">
            <a href="https://wa.me/51915013918" target="_blank" rel="noopener noreferrer" className="hidden sm:flex items-center gap-2 bg-gym-green hover:bg-gym-greenHover text-white px-5 py-2.5 rounded-full font-semibold transition-colors text-sm" data-id="element-184">
              <MessageCircle size={18} data-id="element-185" />
              <span className="hidden md:inline" data-id="element-186">Clase Gratis</span>
            </a>

            {/* Hamburger button */}
            <button onClick={() => setIsOpen(!isOpen)} className="lg:hidden flex items-center justify-center w-10 h-10 rounded-lg bg-gym-charcoalLight border border-gym-charcoal text-white hover:border-gym-green/50 transition-colors" aria-label="Abrir menú" data-id="element-187">
              {isOpen ? <X size={22} data-id="element-188" /> : <Menu size={22} data-id="element-189" />}
            </button>
          </motion.div>
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      <AnimatePresence data-id="element-190">
        {isOpen && <>
            {/* Backdrop */}
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} transition={{
          duration: 0.2
        }} className="fixed inset-0 z-40 bg-black/70 backdrop-blur-sm" onClick={() => setIsOpen(false)} data-id="element-191" />

            {/* Menu Panel */}
            <motion.nav initial={{
          x: '100%'
        }} animate={{
          x: 0
        }} exit={{
          x: '100%'
        }} transition={{
          type: 'spring',
          damping: 30,
          stiffness: 300
        }} className="fixed top-0 right-0 bottom-0 z-50 w-[280px] bg-gym-dark border-l border-gym-charcoalLight flex flex-col" data-id="element-192">
              {/* Menu Header */}
              <div className="flex items-center justify-between px-6 h-20 border-b border-gym-charcoalLight" data-id="element-193">
                <span className="text-lg font-heading font-bold text-white uppercase tracking-wider" data-id="element-194">
                  Menú
                </span>
                <button onClick={() => setIsOpen(false)} className="w-10 h-10 flex items-center justify-center rounded-lg bg-gym-charcoalLight text-white hover:bg-gym-charcoal transition-colors" aria-label="Cerrar menú" data-id="element-195">
                  <X size={20} data-id="element-196" />
                </button>
              </div>

              {/* Nav Links */}
              <div className="flex-1 overflow-y-auto py-4" data-id="element-197">
                {navLinks.map((link, index) => <motion.button key={link.href} initial={{
              opacity: 0,
              x: 20
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              delay: index * 0.05
            }} onClick={() => handleNavClick(link.href)} className="w-full text-left px-6 py-4 text-base font-medium text-gray-300 hover:text-white hover:bg-gym-charcoalLight transition-colors uppercase tracking-wider border-b border-gym-charcoalLight/30" data-id="element-198">
                    {link.label}
                  </motion.button>)}
              </div>

              {/* Mobile CTA */}
              <div className="p-6 border-t border-gym-charcoalLight" data-id="element-199">
                <a href="https://wa.me/51915013918" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-3 bg-gym-green hover:bg-gym-greenHover text-white w-full py-4 rounded-full font-bold text-base transition-colors" data-id="element-200">
                  <MessageCircle size={22} data-id="element-201" />
                  CLASE GRATIS
                </a>
              </div>
            </motion.nav>
          </>}
      </AnimatePresence>
    </>;
}